import { render, staticRenderFns } from "./rouji.vue?vue&type=template&id=56c9c598&scoped=true&"
import script from "./rouji.vue?vue&type=script&lang=js&"
export * from "./rouji.vue?vue&type=script&lang=js&"
import style0 from "./rouji.vue?vue&type=style&index=0&lang=css&"
import style1 from "./rouji.vue?vue&type=style&index=1&id=56c9c598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c9c598",
  null
  
)

export default component.exports